import { useContext } from "react";
import { AuthContext } from "../auth/AuthContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function useWatchlist() {
  const { accessToken, user } = useContext(AuthContext);

  const ensureAuth = () => Boolean(user && accessToken);

  const add = async (eventId) => {
    if (!ensureAuth()) return { ok: false, auth: false };
    const res = await fetch(`${API_BASE}/api/events/${eventId}/watch/`, {
      method: "POST",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return { ok: res.ok };
  };

  const remove = async (eventId) => {
    if (!ensureAuth()) return { ok: false, auth: false };
    const res = await fetch(`${API_BASE}/api/events/${eventId}/watch/`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return { ok: res.ok };
  };

  const toggle = async (eventId, currentlyWatched) => {
    return currentlyWatched ? remove(eventId) : add(eventId);
  };

  return { add, remove, toggle, isAuthenticated: ensureAuth() };
}
